import { mapUnloRoute } from '@dfds-pax/utils'

import { Departure } from '@/states/selection.interface'

import { mapToTrackingProduct, trackAddToCartEcommerce, trackRemoveFromCartEcommerce } from './_ecommerce/cart'
import { trackDepartureAddedSegment, trackDepartureRemovedSegment } from './_segment/cart'
import { DepartureTrackingContext } from './_segment/cartPayload'

const buildDepartureProduct = (isReturnLeg: boolean, departure: Departure, context: DepartureTrackingContext) => {
  const vehicle = context.trailerCode ? `${context.vehicleCode}|${context.trailerCode}` : context.vehicleCode
  return mapToTrackingProduct(
    vehicle,
    mapUnloRoute(`${departure.departurePortCode}-${departure.arrivalPortCode}`),
    departure.departureDate,
    departure.departureTime,
    departure.offer?.code ?? 'UNDEFINED',
    departure.departurePrice,
    1,
    departure.productCode,
    'SeabookDeparture',
    isReturnLeg
  )
}

export const trackAddDeparture = (
  isReturnLeg: boolean,
  departure: Departure | null | undefined,
  context: DepartureTrackingContext
): void => {
  if (!departure) return
  trackAddToCartEcommerce(buildDepartureProduct(isReturnLeg, departure, context), departure.currencyCode)
  trackDepartureAddedSegment(isReturnLeg ? 'home' : 'out', departure, context)
}

export const trackRemoveDeparture = (
  isReturnLeg: boolean,
  departure: Departure | null | undefined,
  context: DepartureTrackingContext
): void => {
  if (!departure) return
  trackRemoveFromCartEcommerce(buildDepartureProduct(isReturnLeg, departure, context))
  trackDepartureRemovedSegment(isReturnLeg ? 'home' : 'out', departure, context)
}
